import { Slide, Stack, Typography } from '@mui/material';
import React from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as CloseIcon } from 'new/components/icons/close-cross.svg';
import { IconButton } from 'new/elements/IconButton';
import classes from './ExpandActions.module.scss';

interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  children: React.ReactNode;
  featureBadge?: React.ReactNode;
}

export const InfoModal = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  featureBadge,
}: InfoModalProps) => {
  const flowContainer = document.querySelector('.react-flow');
  if (!flowContainer) return null;

  const handleBackdropClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <Slide direction="up" in={isOpen} unmountOnExit>
      <div className={classes.modalBackdrop} onClick={handleBackdropClick}>
        <Stack gap="16px" className={classes.externalTriggerUsageContainer}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap="36px"
            paddingRight="16px"
          >
            <Stack>
              <Typography>
                {title}
                {featureBadge}
              </Typography>
              <Typography variant="body2">{description}</Typography>
            </Stack>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <div className={classes.content}>{children}</div>
        </Stack>
      </div>
    </Slide>,
    flowContainer,
  );
};
